import styled, { css } from 'styled-components'
import { BtnComponent } from 'LibNeo/components/Basic/Buttons/Button'
import { FormNotificationComponent, IconComponent, Indent, themeColor } from 'LibNeo'
import { AutoComplete } from 'antd'
import { LabelWrapper } from 'LibNeo/components/Basic/Label/TooltipLabel/styled'

export const FormBlock = styled(Indent)<WithSpacing>`
	width: 100%;
	display: flex;

	${({ withSpacing }) => withSpacing && 'margin-bottom: 8px;'}

	${LabelWrapper} {
		font-size: 12px;
	}
`

type WithSpacing = { withSpacing?: boolean }

export const Half = styled.div<WithSpacing>`
	${({ withSpacing }) => withSpacing && 'margin-right: 8px;'}
	flex: 1;
`

export const FinalPlaceAlert = styled(FormNotificationComponent)`
	width: 100%;
`

export const SaveAddress = styled(BtnComponent)`
	width: auto;
`

export const AddressLabel = styled.div`
	display: flex;
	margin: 0 0 4px 0;
`

export const AddressText = styled.div`
	font-size: 14px;
	line-height: 20px;
	color: ${themeColor('gray', 5)};
`

export const Icon = styled(IconComponent)``

export const AutoCompleteStyled = styled(AutoComplete)<{ isError: boolean }>`
	width: 100%;
	&__container {
		display: flex;
		flex-direction: column;
		margin-bottom: 16px;
	}

	&__label {
		display: flex;
		margin: 0 0 4px 0;

		.ppneo-autocomplete-textarea__text {
			font-size: 14px;
			line-height: 20px;
			color: ${themeColor('gray', 5)};
		}

		.ppneo-autocomplete-textarea__link {
			margin: 0 0 0 auto;
			font-size: 14px;
			line-height: 16px;
			color: ${themeColor('emerald', 5)};
			text-decoration: underline dotted;
			cursor: pointer;
		}

		${Icon} {
			margin: 0 0 0 4px;
		}
	}

	&--disabled {
		cursor: not-allowed;
		opacity: 0.6;
	}

	.ant-input-disabled {
		opacity: 0.6;
	}

	textarea.ant-input.ant-select-search__field {
		min-height: 20px;
		padding: 9px 16px;
		resize: none;
		border-radius: 6px;
		font-size: 14px;
		line-height: 20px;
		margin: 0;
		border: 1px solid ${themeColor('gray', 3)};
		color: ${themeColor('extraBackground3')};

		&::placeholder {
			color: ${themeColor('gray', 4)};
		}

		&:hover {
			border: 1px solid ${themeColor('gray', 5)};
		}
	}

	&.ant-select-focused {
		textarea.ant-input.ant-select-search__field {
			border: 1px solid ${themeColor('emerald', 5)};
		}
	}

	${({ isError }) =>
		isError &&
		css`
			textarea.ant-input.ant-select-search__field {
				border: 1px solid ${themeColor('pink', 5)};
			}
		`}
`
export const AddressEditWrapper = styled.div`
	padding: 8px;
`
